import React, { ReactElement } from 'react';
import useContext from '../../hooks/useContext';
import { SiteContext } from '../../SiteContext';
import { usePreloadedComponent } from '../../utils/componentLoader';
import ViewportLoader from '../ViewportLoader';
import BlockSpacing from '../../styled/BlockSpacing';
import SliceTracking from './sliceTracking';

interface ISliceLoader<P> {
  children: ReactElement<P>;
  component: string;
  heading?: string;
  isAccent?: boolean;
  isHeadingSlice: boolean;
  loader?: ReactElement | null;
  order: number;
  sliceModifier?: string;
  spacing?: 'none' | 'low' | 'default';
}

const SliceLoader = <P,>({
  children,
  component,
  isAccent,
  isHeadingSlice,
  loader,
  order,
  spacing = 'default',
  ...props
}: ISliceLoader<P>) => {
  const Preloaded = usePreloadedComponent(component);
  const { preload } = useContext(SiteContext);

  if (Preloaded && preload.indexOf(component) >= 0) {
    return (
      <SliceTracking order={order} blockType={component}>
        <BlockSpacing spacing={spacing} isAccent={isAccent}>
          {/* @ts-ignore - We can resolve this when we update the dependencies/types */}
          <Preloaded
            {...props}
            inFold={order < 2}
            titleHeadingLevel={isHeadingSlice ? 1 : undefined}
          />
        </BlockSpacing>
      </SliceTracking>
    );
  }

  return (
    <ViewportLoader loader={loader}>
      <SliceTracking order={order} blockType={component}>
        <BlockSpacing spacing={spacing} isAccent={isAccent}>
          {children}
        </BlockSpacing>
      </SliceTracking>
    </ViewportLoader>
  );
};

export default SliceLoader;
